export const environment = {
    production: false,
    url: "https://staging-empower.amplussolar.com/",
    serverUrl: "http://4.224.80.4/",
    clientId: '9e029027-bd6d-403c-9fae-afe6959cde82',
    secretKey: '86v8Q~Zh4az-MPkes9Kiefru9gzqJzzHHojwVcRq',
    authority: 'https://login.microsoftonline.com/8b24551d-7c2c-4beb-8b61-95f32d9929ef/',
    redirectUri: 'https://staging-empower.amplussolar.com/home',
    tenantId: '8b24551d-7c2c-4beb-8b61-95f32d9929ef'
}